import { faCircle, faPlay, faVolume } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const titles = {
    initial: '',
    welcome: 'Welkom!',
    klankenkaart: 'Klankenkaart',
    stappenplan: 'Stappenplan',
    // stappenplanA: 'Stappenplan A',
    // stappenplanB: 'Stappenplan B',
    spiekbrief: 'Spiekbrief',
    auditief: 'Auditieve oefening',
    flits: 'Flitsprogramma',
    mic: 'Bericht inspreken',
    logbook: 'Logboek',
    settings: 'Instellingen',
    zoomIn: 'Inzoomen',
    zoomOut: 'Uitzoomen',
    wereldkaart: 'Wereldkaart',
    spiekstad: 'Spiekstad',
    klinker: 'Klinkerklankenland',
    medeklinker: 'Medeklinkermeer',
    wondereWoorden: 'Wondere woorden woestijn',
    spaceWoorden: 'Spacewoorden',
};

export const texts = {
    initial: '',
    welcome: (
        <p>
            Dit is de start van je reis. Je bent nu hier, bij de rode pin. De
            rode pin verplaatst zich wanneer jij verder op weg bent in je reis
            door Spiek Digitaal. Door de rode pin zie je altijd waar je bent.
        </p>
    ),
    klankenkaart: (
        <p>
            Dit is de klankenkaart. Klik hier om de klankenkaart te openen. Op
            de klankenkaart vind je alle klanken in de kleuren die bij de
            klanken horen. Tijdens het oefenen mag je de klankenkaart altijd
            gebruiken.
        </p>
    ),
    stappenplan: (
        <p>
            Dit is het stappenplan. Klik hier om het stappenplan te bekijken.
            Het stappenplan helpt je om woorden goed te schrijven. Je mag het
            stappenplan tijdens het oefenen er altijd bij pakken.
        </p>
    ),
    stappenplanA: (
        <ol>
            <li>Luister en zeg na</li>
            <li> Welke klanken hoor je? Hak het woord in stukken</li>
            <li> Kleur of leg de blokjes</li>
            <li> Schrijf het woord met letters</li>
            <li> Lees het woord hardop; heb je het goed geschreven?</li>
        </ol>
    ),
    stappenplanB: (
        <ol>
            <li> Luister en zeg na</li>
            <li> Verdeel het woord in klankgroepen</li>
            <li> Welke klank hoor je aan het eind van elke klankgroep?</li>
            <li> Even spieken!</li>
            <li> Schrijf het woord op en lees het na</li>
        </ol>
    ),
    spiekbrief: (
        <p>
            Dit is Spiek. Klik hier voor de Spiekbrief. Op de Spiekbrief vind je
            alle spellingmoeilijkheden die je leert. Tijdens het oefenen mag je
            altijd op de Spiekbrief spieken. In deze Spiekbrief zitten filmpjes
            waarin de spellingmoeilijkheden worden uitgelegd. Tijdens je reis
            door Spiek Digitaal ga je de filmpjes vrijspelen. Je start een
            filmpje door op de <FontAwesomeIcon icon={faPlay} /> knop te
            klikken. Je kan deze filmpjes altijd opnieuw bekijken. Daarnaast kan
            je ook alleen naar de uitleg van de spellingmoeilijkheid luisteren
            door op de <FontAwesomeIcon icon={faVolume} /> te klikken.
        </p>
    ),
    auditief: (
        <p>
            Hier vind je de auditieve oefeningen. Klik hier om jouw auditieve
            oefeningen voor deze week te starten.
        </p>
    ),
    flits: (
        <p>Hier vind je het flitsprogramma. Klik hier om te gaan flitsen.</p>
    ),
    mic: (
        <p>
            Hier kan je een bericht voor je behandelaar inspreken. Heb je ergens
            een vraag over? Spreek dan een kort bericht in. Dit doe je door op
            het rode <FontAwesomeIcon icon={faCircle} /> te klikken, je bericht
            in te spreken en je opname te stoppen door weer op het rode{' '}
            <FontAwesomeIcon icon={faCircle} /> te klikken. Verstuur daarna je
            bericht door op het vliegtuigje te klikken. Tijdens de volgende
            behandeling zal je behandelaar jouw vraag beantwoorden.{' '}
        </p>
    ),
    logbook: (
        <p>
            Dit is jouw logboek. In het logboek zie je wanneer je wat gaat
            oefenen. Ook vind je hier jouw doelen voor lezen en spellen, en de
            succescriteria voor deze week.
        </p>
    ),
    settings: <p>Hier vind je je persoonlijke instellingen. </p>,
    zoomIn: (
        <p>
            Dit is de inzoomknop. Door op de plus te klikken, zoom je in op de
            kaart.
        </p>
    ),
    zoomOut: (
        <p>
            Dit is de uitzoomknop. Door op de min te klikken, zoom je uit om de
            hele kaart te bekijken.
        </p>
    ),
    wereldkaart: (
        <p>
            Tijdens je reis door Spiek Digitaal ga je verschillende werelden
            ontdekken. De naam van de werelden zegt iets over wat je in die
            wereld gaat leren. Ook kun je door de kleur of de afbeeldingen van
            de tegel ontdekken wat je gaat leren. Kijk maar eens rond, herken je
            al iets? Tijdens het maken van de oefeningen of het bekijken van de
            spiekfilmpjes zul je dingen terugzien uit de verschillende werelden.
        </p>
    ),
    spiekstad: (
        <p>
            In deze stad leer je iets nieuws om te gebruiken tijdens het
            oefenen. Spiekstad heeft een grijze tegel.
        </p>
    ),
    klinker: (
        <p>
            In deze wereld komen alle klanken aan bod. Je herkent Klinker
            klanken land aan de tegel met het groene gras.
        </p>
    ),
    medeklinker: (
        <p>
            In deze wereld ga je oefenen met medeklinkers. Je herkent het
            Medeklinkermeer aan de tegel met het blauwe water.
        </p>
    ),
    wondereWoorden: (
        <p>
            In deze woestijn leer je woorden die je anders hoort dan dat je ze
            schrijft. Het zijn wondere woorden. De tegel van de Wondere woorden
            woestijn is beige net als het zand in de woestijn.
        </p>
    ),
    spaceWoorden: (
        <p>
            Spacewoorden zijn woorden die van een andere planeet komen. In
            spacewoorden zitten klanken die anders uitgesproken worden dan in
            onze wereld. De tegel van de spacewoorden herken je aan het
            donkerblauwe heelal.
        </p>
    ),
};
